import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FactSection } from './FactSection';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const f = (fact)=>fact;
const DEADLINE_LABELS = {
    proposal_due: 'Proposal Due',
    questions_due: 'Questions Due',
    opt_in: 'Opt In',
    oral_presentation: 'Oral Presentation',
    site_visit: 'Site Visit',
    pre_proposal_conference: 'Pre-Proposal Conference',
    amendment_response: 'Amendment Response'
};
export function EventsView({ pipeline, projectId }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-5",
        children: [
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Deadlines",
                facts: pipeline.deadlines ?? [],
                accent: "red",
                projectId: projectId,
                titleFn: (v)=>[
                        f(v).date,
                        f(v).time,
                        f(v).timezone
                    ].filter(Boolean).join(' ') || 'Deadline',
                metaFn: (v)=>DEADLINE_LABELS[f(v).type] || f(v).type?.replace(/_/g, ' ')
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Oral Presentations / Demos",
                facts: pipeline.oralPresentations ?? [],
                accent: "amber",
                projectId: projectId,
                titleFn: (v)=>f(v).format || 'Oral presentation',
                metaFn: (v)=>{
                    const parts = [];
                    if (f(v).attendeesAllowed) parts.push(`${f(v).attendeesAllowed} attendees`);
                    if (f(v).durationMinutes) parts.push(`${f(v).durationMinutes} min`);
                    return parts.join(' · ') || (f(v).required ? 'Required' : 'Optional');
                }
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Q&A Protocol",
                facts: pipeline.qaProtocol ?? [],
                accent: "amber",
                projectId: projectId,
                titleFn: (v)=>f(v).submissionMethod || 'Q&A submission',
                metaFn: (v)=>f(v).deadline || undefined
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Site Visits",
                facts: pipeline.siteVisits ?? [],
                accent: "amber",
                projectId: projectId,
                titleFn: ()=>'Site visit'
            }),
            /*#__PURE__*/ _jsx(FactSection, {
                label: "Pre-Proposal Conferences",
                facts: pipeline.preProposalConfs ?? [],
                accent: "amber",
                projectId: projectId,
                titleFn: ()=>'Pre-proposal conference'
            })
        ]
    });
}
